const TXMap3 = {
  map: undefined, // 地图对象
  mapMarkerCluster: undefined, //点聚合
  mapMarker: undefined, //点标记
  markerGeometries: [],
  clusterBubbleList: [],
  overlays: [], // 所有覆盖物
  sourceData: [], // 原始数据
  //
  getApi (funName) {
    let script = document.createElement("script");
    script.type = "text/javascript";
    script.src = `https://map.qq.com/api/gljs?v=1.exp&key=5DXBZ-CA46D-B4244-HE4I6-2E46E-JZFNC&callback=${funName}`;
    document.body.appendChild(script);
    let locationScript = document.createElement("script");
    locationScript.type = "text/javascript";
    locationScript.src =
      "https://mapapi.qq.com/web/mapComponents/geoLocation/v/geolocation.min.js";
    document.body.appendChild(locationScript);
    window.qq = {};
  },
  initMap (options) {
    let _this = this;
    //定义地图中心点坐标
    var center = new TMap.LatLng(
      options.lat || 39.98412,
      options.lng || 116.307484
    );
    //定义map变量，调用 TMap.Map() 构造函数创建地图
    // 初始化地图中心
    _this.map = new TMap.Map(document.getElementById(options.containerId), {
      center: center //设置地图中心点坐标
    });
    if (options.useLocation) {
      _this.location();
    }
  },
  /**
   * 定位
   */
  location () {
    let _this = this;
    var geolocation = new qq.maps.Geolocation(
      "5DXBZ-CA46D-B4244-HE4I6-2E46E-JZFNC",
      "jhh"
    );
    geolocation.getIpLocation(
      function (position) {
        _this.setLocation(position);
      },
      function () {
        let position = {
          accuracy: 10000,
          adcode: 310106,
          addr: "",
          city: "上海市",
          district: "",
          lat: 31.22352,
          lng: 121.45591,
          module: "geolocation",
          nation: "中国",
          province: "上海市",
          type: "ip"
        };
        _this.setLocation(position);
      }
    );
  },
  setLocation (position) {
    this.map.setCenter(new TMap.LatLng(position.lat, position.lng));
  },
  /**
   *初始化map
   */
  txMap (options) {
    this.initMap(options);
  },
  marker (options) {
    let _this = this;
    _this.sourceData = options.data || [];
    if (_this.map === undefined) {
      _this.txMap(options);
    }
    _this.mapMarkerCluster = new TMap.MarkerCluster({
      map: _this.map,
      geometries: _this._covertMakerPosition(),
      enableDefaultStyle: false, //默认样式
      minimumClusterSize: 2, //最小聚合
      zoomOnClick: true, //点击聚合数字放大展开
      gridSize: 1, //聚合算法的可聚合距离，即距离小于该值的点会聚合至一起，默认为60，以像素为单位
      averageCenter: false, //每个聚和簇的中心是否应该是聚类中所有标记的平均值
      maxZoom: 16 //采用聚合策略的最大缩放级别，若地图缩放级别16大于该值，则不进行聚合，标点将全部被展开
    });
    // 监听聚合簇变化
    _this.mapMarkerCluster.on("cluster_changed", function (e) {
      // 销毁旧聚合簇生成的覆盖物
      if (_this.clusterBubbleList.length) {
        _this.clusterBubbleList.forEach(item => {
          item.destroy();
        });
        _this.clusterBubbleList = [];
      }
      _this.markerGeometries = [];
      var clusters = _this.mapMarkerCluster.getClusters();
      clusters.forEach(item => {
        if (item.geometries.length > 1) {
          //点聚合
          let clusterBubble = new window.CustomOverlay({
            map: _this.map,
            position: item.center,
            content: item.geometries.length
          });
          clusterBubble.on("click", () => {
            _this.map.fitBounds(item.bounds);
          });
          clusterBubble.setMap(_this.map);
          _this.clusterBubbleList.push(clusterBubble);
        } else {
          _this.markerGeometries.push({
            styleId: item.geometries[0].properties.id,
            // content: item.geometries[0].properties.address,
            position: item.center
          });
        }
      });
      //单个渲染
      if (_this.mapMarker) {
        _this.mapMarker.setGeometries(_this.markerGeometries);
      } else {
        _this.mapMarker = new TMap.MultiMarker({
          map: _this.map,
          styles: {
            d1: new TMap.MarkerStyle({
              width: 34,
              height: 42,
              anchor: {
                x: 17,
                y: 21
              },
              src: require("../../assets/images/marker/marker_1.png")
            }),
            d2: new TMap.MarkerStyle({
              width: 34,
              height: 42,
              anchor: {
                x: 17,
                y: 21
              },
              src: require("../../assets/images/marker/marker_2.png")
            }),
            d3: new TMap.MarkerStyle({
              width: 34,
              height: 42,
              anchor: {
                x: 17,
                y: 21
              },
              src: require("../../assets/images/marker/marker_3.png")
            }),
            d4: new TMap.MarkerStyle({
              width: 34,
              height: 42,
              anchor: {
                x: 17,
                y: 21
              },
              src: require("../../assets/images/marker/marker_4.png")
            }),
            default: new TMap.MarkerStyle({
              width: 34,
              height: 42,
              anchor: {
                x: 17,
                y: 21
              },
              src: require("../../assets/images/marker/marker_1.png")
            })
          },
          geometries: _this.markerGeometries
        });
      }
    });
    // 自定义覆盖物
    if (window.CustomOverlay === undefined) {
      window.CustomOverlay = function (options) {
        this.options = options;
        TMap.DOMOverlay.call(this, options);
      };
      window.CustomOverlay.prototype = new TMap.DOMOverlay();
      window.CustomOverlay.prototype.onInit = function (options) {
        this.content = options.content;
        this.position = options.position;
      };
      // 销毁时需要删除监听器
      window.CustomOverlay.prototype.onDestroy = function () {
        this.dom.removeEventListener("click", this.onClick);
        this.removeAllListeners();
      };
      window.CustomOverlay.prototype.onClick = function () {
        this.emit("click");
      };
      window.CustomOverlay.prototype.createDOM = function () {
        var dom = document.createElement("div");
        dom.innerText = this.content;
        if (this.content <= 20) {
          dom.classList.add("clusterBubble1");
        } else if (this.content > 20 && this.content <= 50) {
          dom.classList.add("clusterBubble2");
        } else if (this.content > 51 && this.content <= 100) {
          dom.classList.add("clusterBubble3");
        } else {
          dom.classList.add("clusterBubble4");
        }

        // 监听点击事件，实现zoomOnClick
        this.onClick = this.onClick.bind(this);
        // pc端注册click事件，移动端注册touchend事件
        dom.addEventListener("click", this.onClick);
        return dom;
      };
      window.CustomOverlay.prototype.updateDOM = function () {
        if (!_this.map) {
          return;
        }
        // 经纬度坐标转容器像素坐标
        let pixel = _this.map.projectToContainer(this.options.position);

        // 使文本框中心点对齐经纬度坐标点
        let left = pixel.getX() - this.dom.clientWidth / 2 + "px";
        let top = pixel.getY() - this.dom.clientHeight / 2 + "px";
        this.dom.style.transform = `translate(${left}, ${top})`;

        this.emit("dom_updated");
      };
    }
  },
  _covertMakerPosition () {
    let _this = this;
    let geometries = [];
    let forData = function (type, array) {
      if (array && array.length > 0) {
        array.forEach(el => {
          el.id = type;
          const position = {
            styleId: type,
            position: new TMap.LatLng(el.latitude, el.longitude),
            properties: el
            // ,
            // content: el.address
          };
          geometries.push(position);
        });
      }
    };
    let d1 = _this.sourceData["d1"];
    forData("d1", d1);
    let d2 = _this.sourceData["d2"];
    forData("d2", d2);
    let d3 = _this.sourceData["d3"];
    forData("d3", d3);
    let d4 = _this.sourceData["d4"];
    forData("d4", d4);
    return geometries;
  }
};
export default TXMap3;



// WEBPACK FOOTER //
// ./src/components/orderMap/TXMap3.js